import { useIntl } from 'react-intl'
import { LUXURY_PLUS } from 'luxPlus/constants/base'
import PageBanner from 'LuxKit/Banners/PageBanner'
import LineExclamationTriangleIcon from 'LuxKit/Icons/line/LineExclamationTriangleIcon'

function LuxPlusWarningMessageBanner() {
  const intl = useIntl()

  return <PageBanner
    kind="warning"
    align="center"
    icon={<LineExclamationTriangleIcon />}
  >
    {intl.formatMessage(
      { id: 'TZjA506Cg6q-Zen4xixA', defaultMessage: 'We are currently experiencing issues with your {programName} membership. Our team is on it. Please check back later.', description: 'Warning banner message when there are issues with LuxPlus membership' },
      { programName: LUXURY_PLUS.PROGRAM_NAME },
    )}
  </PageBanner>
}

export default LuxPlusWarningMessageBanner
